import { Auth0Provider, type AppState } from '@auth0/auth0-react'
import { useCallback } from 'react'
import { useNavigate } from 'react-router'

interface AuthProviderProps {
  children: React.ReactNode
  domain: string
  clientId: string
  audience?: string
}

export function AuthProvider({ children, domain, clientId, audience }: AuthProviderProps) {
  const navigate = useNavigate()

  const onRedirectCallback = useCallback(
    (appState?: AppState) => {
      const returnTo = appState?.returnTo ?? sessionStorage.getItem('auth_return_to') ?? '/'
      sessionStorage.removeItem('auth_return_to')
      navigate(returnTo)
    },
    [navigate],
  )

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        ...(audience ? { audience } : {}),
      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens
      useRefreshTokensFallback
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  )
}
